import React, {FC} from "react";
import {PreviewImageProps} from "./PreviewImage-types";
import {Root, SvgBase, PngMask, Warning} from "./PreviewImage-styles";


const PreviewImage: FC<PreviewImageProps> = (props) => {
    const {svg, mask, references, uid} = props;

    return (
        <Root>

            {
                svg &&
                <SvgBase
                    reference={(el) => references.current[uid] = el}
                    svgEncodedBase64={svg}
                    sectionId={uid} />
            }
            {
                mask &&
                <PngMask>
                    <img src={mask} alt=""/>
                </PngMask>
            }
            {
                !svg &&
                <Warning>Этот конструктор еще недоступен</Warning>
            }

        </Root>
    )
};

export default PreviewImage;
